























import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import AppAdo from "@/components/app-ado.vue";
import { mapGetters } from "vuex";
import store from "@/store";
export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    let error: string = to.fullPath.split("/erreurs/")[1];
    console.error(error);
    store
      .dispatch("saveErrorLog", error)
      .then(() =>
        error.toLowerCase().includes("typeerror") ? next("/erreurs/default") : next()
      );
    next();
  },
  components: { AppLayout, AppAdo },
  computed: {
    ...mapGetters("activites", ["getCurrentActivite"]),
  },
});
